export const m = {
  /* order */
  tijiao: "提交",
  name: "姓名",
  idcard: "身份证",
  tijiaoing: "提交中",
  finish: "完成",
  gengduo: "没有更多了",
  xiangqing: "详情",
  yuyan: "切换服务器",
  zy: "1",

  /* tabbar */
  one: "首页",
  tow: "项目",
  three: "客服",
  four: "资讯",
  five: "我的",
  kuaixun: "快讯",
  /* 首页 */
  sy_span0: "迈徳瑞",
  sy_span1: "迈徳瑞中国",
  sy_span2: "成立于2000年",
  sy_span3: "来源：迈徳瑞中国",
  sy_span4: "金融多空持仓比例",
  sy_span6: "投资",
  sy_span7: "详情",
  sy_span8: "周期",
  sy_span9: "余额",
  sy_usdt: "USDT",
  sy_usdt_added: "USDT增值收益",
  sy_span5: "新手项目",
  sy_list1: ["我要充值", "我要提现", "基金", "公司资质", "邀请好友"],
  sy_list2: [
    "每日签到",
    "会员等级",
    "实名认证",
    "我的团队",
    "安全保障",
    "幸运抽奖",
    "积分商城",
    "日利宝",
    "财务明细",
    "我的投资"
  ],
  fwq: "切换服务器",
  syicon1: "每日签到",
  syicon2: "会员等级",
  syicon3: "公司资质",
  syicon4: "邀请好友",
  syicon5: "实名认证",
  ldj: "USD",
  ldy: "USDT",
  hd: "热门活动",
  min: "最低",
  day: "天",
  max: "最高",
  tuijian: "热门推荐",
  rishouyi: "平均日收益",
  qitou: "元起投",
  changgui: "常规",
  shouyiguo: "USDT",
  shouyiguo1: "余额增值收益",
  shouyiguo2: "usdt增值收益",
  mairu: "买入",
  maichu: "卖出",
  lijigoumia: "立即购买",
  jiancang: "建仓",
  jiaoyi: [
    { id: "86176*****082", content: "用户 充值 ", yingli: "69600", yuan: "元" },
    { id: "86188****463", content: "用户 提现 ", yingli: "19940", yuan: "元" },
    { id: "86132****768", content: "用户 盈利 ", yingli: "1720", yuan: "元" }
  ],
  jiaoyi1: [
    {
      id: "86136*****502",
      content: "用户 充值 ",
      yingli: "126800",
      yuan: "元"
    },
    { id: "86152****699", content: "用户 提现 ", yingli: "19200", yuan: "元" },
    { id: "86199****468", content: "用户 盈利 ", yingli: "4396", yuan: "元" }
  ],
  jiaoyi2: [
    { id: "86177*****538", content: "用户 充值 ", yingli: "13790", yuan: "元" },
    { id: "86139****562", content: "用户 提现 ", yingli: "14410", yuan: "元" },
    { id: "86166****799", content: "用户 盈利 ", yingli: "6510", yuan: "元" }
  ],
  jiaoyi3: [
    { id: "86136*****052", content: "用户 充值 ", yingli: "23930", yuan: "元" },
    { id: "86177****563", content: "用户 提现 ", yingli: "11330", yuan: "元" },
    { id: "86162****796", content: "用户 盈利 ", yingli: "673", yuan: "元" }
  ],
  jiaoyi4: [
    { id: "86153*****386", content: "用户 充值 ", yingli: "15570", yuan: "元" },
    { id: "86168****468", content: "用户 提现 ", yingli: "14660", yuan: "元" },
    { id: "86135****769", content: "用户 盈利 ", yingli: "3220", yuan: "元" }
  ],
  jiaoyi5: [
    { id: "86182*****062", content: "用户 充值 ", yingli: "13000", yuan: "元" },
    { id: "86155****763", content: "用户 提现 ", yingli: "1168", yuan: "元" },
    { id: "86152****760", content: "用户 盈利 ", yingli: "596", yuan: "元" }
  ],
  jiaoyi6: [
    { id: "86137*****388", content: "用户 充值 ", yingli: "27800", yuan: "元" },
    { id: "86199****690", content: "用户 提现 ", yingli: "31100", yuan: "元" },
    { id: "86186****762", content: "用户 盈利 ", yingli: "1540", yuan: "元" }
  ],
  jiaoyi7: [
    { id: "86199*****082", content: "用户 充值 ", yingli: "37500", yuan: "元" },
    { id: "86156****468", content: "用户 提现 ", yingli: "18200", yuan: "元" },
    { id: "86176****563", content: "用户 盈利 ", yingli: "3700", yuan: "元" }
  ],
  jiaoyi8: [
    { id: "86166*****881", content: "用户 充值 ", yingli: "19480", yuan: "元" },
    { id: "86179****466", content: "用户 提现 ", yingli: "16740", yuan: "元" },
    { id: "86186****795", content: "用户 盈利 ", yingli: "720", yuan: "元" }
  ],
  jiaoyi9: [
    { id: "86135*****062", content: "用户 充值 ", yingli: "24800", yuan: "元" },
    { id: "86138****461", content: "用户 提现 ", yingli: "18340", yuan: "元" },
    { id: "86156****290", content: "用户 盈利 ", yingli: "2320", yuan: "元" }
  ],
  /* 个人中心 */
  list1: [
    "财务明细",
    "我的团队",
    "银行卡",
    "实名认证",
    "日利宝",
    "我的投资",
    "积分商城",
    "邀请好友"
  ],
  list2: [
    // "安全保障",
    "提现记录",
    "充值记录",
    "兑换记录",
    "互转记录",
    "资产互转",
    "币种兑换",
    "支付密码",
    "登录密码",
    "退出登录"
  ],
  list3: ["收益明细", "我要充值", "我要提现"],
  xinxi: "我的信息",
  xiangguan: "我的相关",
  yue: "我的余额",
  geren: "个人中心",
  yishiming: "已实名",
  weishiming: "未实名",
  /* 签到页面 */
  qd_span01: "每日一签",
  qd_span02: "现金红包领不停",
  qd_span0: "每日签到",
  qd_span1: "今日签到得2元",
  qd_span2: "签到提醒",
  qd_span3: "立即签到",
  qd_span4: "天天签到，每天领礼金",
  qd_span5: "我的积分",
  qd_span6: "邀好友 有机会得丰厚奖励",
  qd_span7: "立即邀请",
  qd_span8: "签到列表",
  qd_span9: "打卡成功",
  /* 自选 */
  zx_span0: "搜索",
  zx_span1: "项目名",
  zx_span2: "起售价",
  zx_span3: "回报率",
  zx_span4: "周期",
  /* 理财详情 */
  lc_span0: "产品详情",
  lc_span1: "项目进度",
  lc_span2: "项目总额",
  lc_span3: "限投次数",
  lc_span4: "招募周期",
  lc_span5: "担保公司",
  lc_span6: "交易规则",
  lc_span7: "申购提交",
  lc_span8: "每日返利",
  lc_span9: "申请提现",
  lc_span10: "今日",
  lc_span11: "24小时后",
  lc_span12: "24小时内到账",
  lc_span13: "常见问题",
  lc_span14: "问",
  lc_span15: "答",
  lc_span16: "该产品起息、到帐规则是什么？",
  lc_span17:
    "该产品随时可存入，当天即起息。存入后若按产品期限持有 到期，则按满期支取收益率兑付本息；",
  lc_span18: "投资理财产品有风险吗？",
  lc_span19:
    "项目受中国证监会监督，是合格境外机构投资者(QFII)持有者，募集资金由工商银行托管，合作保理机构承保，承保单位对平台上的每一笔建仓资金以及股权收益提供100%保障，对本息承诺全额垫付，为投资人保驾护航；",
  lc_span20: "为什么要开通网上银行才能购买？",
  lc_span21:
    "充值余额账户，需要您通过网上银行支付到我们提供的指定账户，才能购买理财产品，所以需要开通网上银行。",
  lc_span22: "投资周期",
  lc_span23: "天",
  lc_span24: "中低风险",
  lc_span25: "金牛品质",
  lc_span26: "净值型",
  lc_span27: "稳定收益",
  lc_span28: "进度",
  lc_span29: "担保",
  lc_span30: "已结束",

  /* 发现 */
  fx_span0: "发现",
  fx_span1: "年终积分 兑换来了",
  fx_span2: "置顶",
  fx_span3: "财经推荐",
  /* 会员等级 */
  dj_span0: "会员等级",
  dj_span1: "下一级可增加加息率参照下表",
  dj_span2: "登记名称",
  dj_span3: "积分限制",
  dj_span4: "加息率",
  dj_span5: "总积分",
  /* 邀请好友 */
  yq_span0: "邀请码",
  yq_span1: "一级上线可以奖励",
  yq_span2: "二级上线可以奖励",
  yq_span3: "三级上线可以奖励",
  yq_span4: "点击下载APP",

  /* 实名认证 */
  sm_span01: "您的名字",
  sm_span02: "请输入您的名字",
  sm_span03: "您的证件号码",
  sm_span04: "请输入您的证件号码",
  sm_span05: "名字",
  sm_span06: "证件号码",
  sm_span0: "实名认证",
  sm_span1: "完成实名认证，保障资金安全 !",
  sm_span2: "上传照片",
  sm_span3: "填写信息",
  sm_span4: "完成认证",
  sm_span5: "上传身份证图片",
  sm_span6: "上传/拍摄人像面",
  sm_span7: "上传/拍摄国徽面",
  sm_span8: "身份信息",
  /* 登录/注册/忘记密码/注册/修改密码 */
  dl_span01: "没有账号？去",
  dl_span02: "注册",
  dl_span03: "新用户注册",
  dl_span04: "输入手机号创建账户",
  dl_span05: "忘记密码",
  dl_span06: "通过手机号找回密码",
  dl_span07: "修改密码",
  dl_span08: "重新设置新的登录密码",
  dl_span09: "重新设置新的支付密码",

  dl_span0: "欢迎登录",
  dl_span1: "欢迎登录迈徳瑞中国",
  dl_span2: "请输入手机号",
  dl_span3: "请输入密码",
  dl_span4: "手机号登录",
  dl_span5: "忘记账号密码",
  dl_span6: "登录",
  dl_span7: "注册账号",
  dl_span8: "短信验证码",
  dl_span9: "发送验证码",
  dl_span10: "自动读取短信验证码",
  dl_span11: "密码登录",
  dl_span12: "登录中",
  dl_span13: "重发 ",
  dl_span14: "邀请码 ",
  dl_span15: "通过注册，代表您同意我们的使用条款和条件",
  dl_span16: "欢迎来到华为商城，请使用手机号注册",
  dl_span17: "欢迎来到范达投资，请设置您的新密码",
  dl_span18: "请确认密码",
  dl_span19: "请输入原密码",
  dl_span20: "请输入新密码",
  dl_span21: "修改登录密码",
  dl_span22: "修改支付密码",
  dl_span23: "登陆方式",
  dl_span24: "记住账号密码",
  /* 交易 */
  jy_span01: "资产保障中",
  jy_span02: "总资产折合(CNY)",
  jy_span03: "持仓",
  jy_span04: "隐藏未启动持仓",
  jy_span05: "操作记录",

  jy_span0: "交易",
  jy_span1: "总资产(元)",
  jy_span2: "预估收益",
  jy_span3: "总收益",
  jy_span4: "充值",
  jy_span5: "提现",
  jy_span6: "我的持有",
  jy_span7: "持仓金额",
  jy_span8: "日利率",
  jy_span9: "持仓收益",
  jy_span10: "已收本息",
  jy_span11: "待收本息",
  jy_span12: "已收USDT",
  jy_span13: "待收USDT",
  /* 积分商城列表/详情 */
  jf_span01: "积分账户",
  jf_span02: "兑换明细",
  jf_span03: "特惠活动",
  jf_span04: "积分特惠，好礼换不停",
  jf_span05: "去签到",
  jf_span0: "积分商城",
  jf_span1: "可用积分",
  jf_span2: "资金明细",
  jf_span3: "历史订单",
  jf_span4: "人",
  jf_span5: "规格参数",
  jf_span6: "兑换数量",
  jf_span7: "备注",
  jf_span8: "可输入备注",
  jf_span9: "立即兑换",
  jf_span10: "商品简介",
  /* 积分商城提交订单*/
  jf_span11: "提交订单",
  jf_span12: "收货人",
  jf_span13: "手机号码",
  jf_span14: "选择地区",
  jf_span15: "详情地址",
  jf_span16: "商品信息",
  jf_span17: "付款成功",
  /* 财务明细*/
  cw_span1: "财务明细",
  cw_span2: "已收利息",
  cw_span3: "待收利息",
  cw_span4: "财务列表",
  cw_span5: "待收USDT",
  cw_span6: "已收USDT",
  /* 我的团队*/
  td_span0: "我的团队",
  /* 我的投资*/
  tz_span0: "我的投资",
  tz_span1: "订单号码",
  tz_span2: "倒计时",
  tz_span3: "已获收益",
  tz_span4: "金额",
  tz_span5: "收获金额",
  tz_span6: "互转时间",
  /* 日利宝*/
  rlb_span0: "日利宝",
  rlb_span1: "可转入金额",
  rlb_span2: "累计收益",
  rlb_span3: "万份收益(元)",
  rlb_span4: "转出金额",
  rlb_span5: "转入金额",
  rlb_span6: "转出转入明细",
  rlb_span7: "总金额(元)",
  rlb_span8: "转出金额(元)",
  rlb_span9: "转入金额(元)",
  rlb_span10: "请输入转出金额",
  rlb_span11: "请输入转入金额",
  rlb_span12: "确认转出",
  rlb_span13: "确认转入",
  /* 提现、充值、兑换记录*/
  jl_span0: "提现记录",
  jl_span1: "充值记录",
  jl_span2: "兑换记录",
  jl_span3: "客服回复",
  jl_span4: "待审核",
  jl_span5: "已完成",
  jl_span6: "已拒绝",
  jl_span7: "已忽略",
  jl_span8: "兑换时间",
  jl_span9: "已取消",
  jl_span10: "待发货",
  jl_span11: "已发货",
  /* 银行卡*/
  yh_span01: "目前已绑定",
  yh_span02: "快捷支付",
  yh_span0: "银行卡",
  yh_span1: "持卡人姓名",
  yh_span2: "添加银行卡",
  yh_span3: "添加USDT",
  yh_span4: "银行卡号",
  yh_span5: "银行类型",
  yh_span6: "开户行",
  yh_span7: "支付密码",
  yh_span8: "USDT地址",
  /* 充值、提现*/
  ct_span01: "可提现金额（元）",
  ct_span02: "可提现金额（U）",
  ct_span03: "提现金额",
  ct_span04: "全部提现",

  ct_span0: "卡号后4位",
  ct_span1: "下一步",
  ct_span2: "充值前先联系客服",
  ct_span3: "付款方式",
  ct_span4: "银行卡支付",
  ct_span5: "USDT支付",
  ct_span6: "立即付款",
  ct_span7: "账户余额",
  ct_span8: "银行卡提现",
  ct_span9: "USDT提现",
  ct_span10: "账户余额",
  ct_span1c: "USDT",
  ct_span11: "默认为登录密码",
  ct_span12: "USDT充值",
  ct_span13: "扫二维码充值",
  ct_span14: "钱包地址",
  ct_span15: "保存",
  ct_span16: "复制",
  ct_span17: "银行卡充值",
  ct_span18: "USDT充值",
  ct_span19: "数量",
  ct_span20: "请输入充值数量",
  ct_span21: "请输入提现数量",
  ct_span22: "确定充值",
  ct_span23: "本次最多充值金额",
  ct_span24: "请输入充值金额",
  /* 客服*/
  kf_span0: "客服",
  /* 切换服务器*/
  fw_span0: "切换服务器",
  fw_span1: "服务器",
  /* 产品认购 */
  rg_span0: "产品认购",
  rg_span1: "单笔最低 ",
  rg_span11: " ，最高 ",
  rg_span12: "，可投次数 ",
  rg_span2: "，汇率 ",
  rg_span3: "买入结果",
  rg_span4: "下单成功",
  rg_span5: "可前往我的-余额 查看我的资产",
  /* 资产互转 */
  hz_span0: "资产互转",
  hz_span1: "可用USDT",
  hz_span2: "到账数量",
  hz_span3: "转换方式",
  hz_span4: "转换数量",
  hz_span5: "充值卡户名",
  hz_span6: "当前汇率",
  hz_span7: "申请兑换",
  hz_span8: "人民币 --> USDT",
  hz_span9: "USDT --> 人民币",
  hz_span10: "人民币下单",
  hz_span11: "USDT下单",
  hz_span12: "账户充值",
  hz_span13: "立即提现",

  hz_span20: "产品特色",
  hz_span21: "当日起息",
  hz_span211: "节假通用",
  hz_span22: "随时支取",
  hz_span221: "当日到账",
  hz_span23: "银行存款",
  hz_span231: "本金保障",
  hz_span19: "产品详情",
  hz_span24: "收益计算",
  hz_span25: "计息方式",
  hz_span26: "收益计算：",
  hz_span27:
    "返利期满收益：本金1100.00+本金1100.00x期满收益率0.16%x720天=股权收益2367.20",
  hz_span28: "资产互转",
  hz_span29: "选择语言",
  /* 用户间余额互转 */
  yz_span0: "资产互转",
  yz_span1: "可用余额",
  yz_span2: "收款人",
  yz_span3: "请输入对方手机号",
  yz_span4: "转账币种",
  yz_span5: "转账金额",
  yz_span6: "请输入转账金额",
  yz_span7: "备注（选填）",
  yz_span8: "确认转账",
  yz_span9: "互转记录",
  yz_span10: "人民币余额",
  yz_span11: "USDT",
  yz_span12: "转账成功",
  yz_span13: "转出",
  yz_span14: "转入",
  yz_span15: "转出账号",
  yz_span16: "收款账号"
};
